import React from 'react';

const GpsCoordinateSearch = ({
  value,
  onValueChange,
  onSearch,
  placeholder = "Lat, Lon | DMS | DM | MGRS",
}) => {
  return (
    <form
      className="w-full"
      onSubmit={(e) => {
        e.preventDefault();
        if (onSearch) onSearch();
      }}
    >
      <div className="flex w-full flex-row items-center gap-2">
        <input
          id="gps-coords"
          name="gpsCoords"
          type="text"
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          value={value}
          onChange={(e) => onValueChange?.(e.target.value)}
          style={{ flex: "1 1 0%", minWidth: "50%" }}
        />

        <button
          className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
          type="submit"
        >
          Go
        </button>
      </div>
    </form>
  );
};

export default GpsCoordinateSearch;
